import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/__w/gfh-corporate/gfh-corporate/nuxt/website/layouts/default.vue").then(m => m.default || m))
}